export const PC = 'EXP_PROJECT_CREATOR';
export const AD = 'EXP_ADMIN';
export const SA = 'EXP_SUPER_ADMIN';
export const GU = 'GUEST';

export const roleRestricted = (roles: string | string[], userRole: string) => {
  if (Array.isArray(roles)) {
    return roles.includes(userRole);
  }
  return roles === userRole;
};
